/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
export var ICWindow = /*#__PURE__*/ function() {
    "use strict";
    function ICWindow() {
        _classCallCheck(this, ICWindow);
    }
    var _proto = ICWindow.prototype;
    _proto._removeEventListener = function _removeEventListener() {
        if (this._eventHandler) {
            window.removeEventListener("message", this._eventHandler);
        }
        this._eventHandler = undefined;
    };
    _proto._openWindow = function _openWindow(url, target, feature) {
        this._remove();
        var ref;
        // Open a new window with the IDP provider.
        this._window = (ref = window.open(url, target !== null && target !== void 0 ? target : "icWindow", feature)) !== null && ref !== void 0 ? ref : undefined;
    };
    _proto._remove = function _remove() {
        var ref;
        (ref = this._window) === null || ref === void 0 ? void 0 : ref.close();
        this._removeEventListener();
    };
    return ICWindow;
}();
